import React, {useState} from 'react'

const SVG = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg"
         className="w-12 h-12 p-3 text-blue-400 border border-blue-100 md:w-16 md:h-16 rounded-2xl md:p-3 bg-blue-50"
         fill="none"
         viewBox="0 0 24 24" stroke="currentColor"
    >
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"
            d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
    </svg>
  )
}

const PopUp = (props) => {
  const { heading, text, details, buttonText, buttonColor } = props
  const detailList = Array.isArray(details) ? details.filter(Boolean) : []
  const [isOpen, setOpen] = useState(true)

  const handleClick = () => {
    props.handlePopUp()
    setOpen(!isOpen)
  }

  return (
    <div
      className={`${!isOpen ? 'hidden' : 'block'} flex flex-col space-y-4 min-w-screen h-screen animated fadeIn faster  fixed  left-0 top-0 justify-center items-center inset-0 z-50 outline-none focus:outline-none bg-gray-900 bg-opacity-30`}
    >
      <div className="flex flex-col p-2 bg-white shadow-md md:p-8 hover:shadow-lg rounded-2xl">
        <div className="flex flex-col items-center justify-between md:flex-row">
          <div className="flex items-center mt-4 md:mt-0">
            <SVG/>
            <div className="flex flex-col ml-3">
              <div className="font-medium leading-snug">{heading || 'Notification'}</div>
              {detailList.length > 0 ? (
                <ul className="mt-2 text-sm text-gray-700 list-disc list-inside">
                  {detailList.map((item) => <li key={item} className="mt-1">{item}</li>)}
                </ul>
              ) : text ? (
                <p className="mt-1 text-sm leading-snug text-gray-600">
                  {text}
                </p>
              ) : null}
            </div>
          </div>
          <button
            className={`flex-no-shrink ${buttonColor || 'bg-red-500 border-red-500'} px-5 my-4 md:my-0 md:ml-4 py-2 text-sm shadow-sm hover:shadow-lg font-medium tracking-wider border-2 text-white rounded-full`}
            onClick={handleClick}
          >
            {buttonText || 'Close'}
          </button>
        </div>
      </div>
    </div>
  )
}

export default PopUp